export const addTransferAmtsToYearArr = (gameYear, savingsClass, yearArr, transferFee, transferAmt ) => {
    
    transferFee = transferFee.toString();
    if (transferFee > 0){
        const yearArrIndx = yearArr.findIndex(elem => elem.year === gameYear);
        if (yearArrIndx === -1){
            const yearObj = {year: gameYear, totalInterest: 0, penaltyAmt: transferFee};
            yearArr.push(yearObj);
        }else{
            if (yearArr[yearArrIndx].penaltyAmt){
                yearArr[yearArrIndx].penaltyAmt = (+yearArr[yearArrIndx].penaltyAmt + +transferFee).toString();
            }else{
                yearArr[yearArrIndx] = {...yearArr[yearArrIndx], penaltyAmt: transferFee};
            }
        }
    }
    if (transferAmt > 0 && savingsClass === "retirement"){
        const yearArrIndx = yearArr.findIndex(elem => elem.year === gameYear);
        transferAmt = transferAmt.toString();
        if (yearArrIndx === -1){
            const yearObj = {year: gameYear, totalInterest: 0, penaltyAmt: 0, transferAmt: transferAmt};
            yearArr.push(yearObj);
        }else{
            // transfer amount is only valid for 401K as it is the only savings that is pre-tax
            if (yearArr[yearArrIndx].transferAmt){
                yearArr[yearArrIndx].transferAmt = (+yearArr[yearArrIndx].transferAmt + +transferAmt).toString();
            }else{
                yearArr[yearArrIndx] = {...yearArr[yearArrIndx], transferAmt: transferAmt};
            }
        }
    }
    return yearArr;

}

export default addTransferAmtsToYearArr;